import parse, {
    attributesToProps,
    domToReact,
    HTMLReactParserOptions,
    DOMNode,
    Element,
} from 'html-react-parser';
import DOMPurify from 'isomorphic-dompurify';
import { phraseLinkClassName } from '@/consts/classNames';

const parseOptions: HTMLReactParserOptions = {
    replace: (domNode: DOMNode) => {
        if (
            domNode instanceof Element &&
            domNode.name === 'a' &&
            domNode.attribs?.target !== '_blank'
        ) {
            const props = attributesToProps(domNode.attribs);
            return (
                <a className={phraseLinkClassName} {...props}>
                    {domToReact(domNode.children as DOMNode[], parseOptions)}
                </a>
            );
        }
    },
};

/**
 * ******************************************************************************************
 * IMPORTANT: Mostly not required outside of usePhrase.
 * Phrases do not need to use both `t` function from usePhrase and `JSXFromString`.
 * ******************************************************************************************
 */
export const JSXFromString = (phrase: ReturnType<typeof parse>): ReturnType<typeof parse> => {
    return typeof phrase === 'string'
        ? parse(DOMPurify.sanitize(phrase, { ADD_ATTR: ['target'] }), parseOptions)
        : phrase;
};
